import React from 'react';
import PropTypes from 'prop-types';
import {
  AppBar, Toolbar, Button, Grid2 as Grid, Typography, Avatar, Link,
  Box, IconButton
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import PersonIcon from '@mui/icons-material/Person';
import 'moment/locale/es';

import { urlImg } from '../common/helpers';

import { useSelector } from 'react-redux';

const Header = ({ changeMenu }) => {
  const navigate = useNavigate();
  const auth = useSelector(state => state.auth);
  const user = useSelector(state => state.auth.user);

  const login = () => {
    navigate('/')
  }

  const irA = donde => () => {
    navigate(donde);
  }

  let bLogin = user && auth.isAuthenticated ? (
    <>
      <Box
        className="menu-header-icon"
        aria-controls="simple-menu"
      >
        {
          <Avatar
            src={`${urlImg}/w_55,h_55,c_fill/v${user.versionAvatar}/users/${user._id}`}
            sx={{ width: 50, height: 50 }}
          />
        }
        <Typography>{user.name}<br /><small>Usuario</small></Typography>
      </Box>
    </>
  ) : (
    <>
      <Button className="btn btn-blue" onClick={login}>
        <PersonIcon className="icon-btn" />
        <span>Iniciar sesión</span>
      </Button>
      <Button className="btn btn-white ml-2" onClick={irA("/signup")}>
        <HowToRegIcon className="icon-btn" />
        <span>Regístrate</span>
      </Button>
    </>
  );

  return (
    <AppBar
      elevation={0}
      color="inherit"
      position="fixed"
      className="navbar navbarScrolled"
    >
      {/* Versión móvil */}
      <Toolbar sx={{ display: { xs: 'block', md: 'none' } }}>
        <Grid
          container
          maxWidth="xl"
          size={12}
          sx={{ padding: 2, maxWidth: { xs: 500, sm: 700, marginInline: "auto" } }}
        >
          <Grid
            size={6}
            item
            sx={{ display: "flex", flexDirection: "row", justifyContent: "flex-start" }}
          >
            {user && auth.isAuthenticated &&
              <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="menu"
                onClick={changeMenu}
              >
                <MenuIcon />
              </IconButton>
            }
            <Link className="link-movil" href="/home">
              <img alt="logo" width="170" src="/logo.png" />
            </Link>
          </Grid>
          <Grid
            size={6}
            item
            sx={{
              display: "flex", justifyContent: "flex-end", alignItems: "center"
            }}
          >
            <Box className="content-movil-actions">
              {bLogin}
            </Box>
          </Grid>
        </Grid>
      </Toolbar>


      {/* Versión web */}
      <Grid className="navbar-content" direction="row" container
        sx={{
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          display: { xs: 'none', md: 'flex' }
        }}
      >
        <Grid item xs={3} md={3} lg={3} className="content-align-center">
          {
            user && auth.isAuthenticated &&
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="menu"
              sx={{ mr: 2 }}
              onClick={changeMenu}
            >
              <MenuIcon />
            </IconButton>
          }
          <Link href="/home">
            <img className="logo" alt="logo" src="/logo.png" />
          </Link>
        </Grid>
        <Grid item xs={9} md={9} lg={8} className="content-web-actions">
          {bLogin}
        </Grid>
      </Grid>
    </AppBar>
  )
}

Header.propTypes = {
  sections: PropTypes.array,
  title: PropTypes.string,
};

export default Header;